import COMMON_API from "../../../api/common";
import API from "../api";

export default {
  namespaced: true,
  state: {
    requestEndorsements: {
      items: [],
      total_count: 0
    },
    endorsements: {
      items: [],
      total_count: 0
    }
  },
  mutations: {
    setListEndorsement(state, payload) {
      state.endorsements = payload;
    },
    setListRequestEndorsement(state, payload) {
      state.requestEndorsements = payload;
    }
  },
  actions: {
    async requestListEndorsement({ commit }, payload) {
      const { data } = await API.getListEndorsement(payload);
      commit("setListEndorsement", data);
      return data;
    },
    async requestListRequestEndorsement({ commit }, payload) {
      const { data } = await API.getListRequestEndorsement(payload);
      commit("setListRequestEndorsement", data);
      return data;
    },
    async requestListEconomicGroup() {
      const { data } = await COMMON_API.getEconomicGroup("");
      return data;
    },
    async requestListTaker(context, payload) {
      const { data } = await API.getListTakerEndorsement(payload);
      return data;
    },
    async requestListPolicy(context, payload) {
      const { data } = await COMMON_API.getPolicy(payload);
      return data;
    }
  },
  modules: {}
};
